import { render, staticRenderFns } from "./data45.vue?vue&type=template&id=5d62671e&scoped=true"
import script from "./data45.vue?vue&type=script&lang=js"
export * from "./data45.vue?vue&type=script&lang=js"
import style1 from "./data45.vue?vue&type=style&index=1&id=5d62671e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d62671e",
  null
  
)

export default component.exports